import React from 'react'

import {
  Icon,
  Verified,
  Tooltip,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import i18n from 'Pods/Shared/I18n'

export function getListingHeaders(cgtStandardEnabled, isSalesBoostEnabled, isSubscriptionColumnEnabled) {

  return [
    {
      value: 'image',
      title: 'Image',
      sortable: false,
      centered: false,
    },
    {
      value: 'title',
      title: 'Name',
      sortable: true,
      centered: false,
    },
    ...(cgtStandardEnabled
      ? [
        {
          value: 'verification',
          title: (
            <div className="display-flex">
              <Tooltip
                id="verification-tooltip"
                containerClass="position-relative"
                tooltipClassName="verification-tooltip cgt-tooltip--top"
                content={(
                  <span className="verification-tooltip__text">
                    {i18n.t('verified', { ns: 'profile' })}
                    <a
                      target="_blank"
                      href="https://help.cgtrader.com/hc/en-us/articles/12602200107281-About-model-standard"
                      rel="noreferrer"
                    >
                      Learn more
                    </a>
                  </span>
                )}
                place="top"
                clickable
                isAdjustable
              >
                <Icon svgComponent={Verified} color="dark" size="small" />
              </Tooltip>
              Verification
            </div>
          ),
          sortable: true,
          centered: false,
        },
      ]
      : []),
    {
      value: 'published_at',
      title: 'Date Added',
      sortable: true,
      centered: false,
    },
    {
      value: 'updated_at',
      title: 'Date Modified',
      sortable: true,
      centered: false,
    },
    {
      value: 'price',
      title: 'Price',
      sortable: true,
      centered: false,
    },
    {
      value: 'publishing_score',
      title: 'Score',
      sortable: true,
      centered: false,
    },
    {
      value: 'pageviews',
      title: 'Views',
      sortable: true,
      centered: false,
    },
    ...(isSalesBoostEnabled ? [{
      value: 'promotionStatus',
      title: 'Promotion',
      sortable: true,
      centered: false,
    }] : []),
    {
      value: 'revenue',
      title: 'Total Earnings',
      sortable: true,
      centered: false,
    },
    {
      value: 'status',
      title: 'Status',
      sortable: true,
      centered: false,
    },
    ...(isSubscriptionColumnEnabled ? [{
      value: 'subscriptionStatus',
      title: 'Subscription',
      sortable: false,
      centered: false,
    }] : []),
    {
      value: 'actions',
      title: 'Actions',
      sortable: false,
      centered: false,
    },
  ]
}
